import parse from "html-react-parser"
import {pair} from "@/library/types/pair"
import {classNames} from "@/library/utilities/html"
import {ProductVersionChange} from "@/library/api/models/changelog"

export default function ChangelogItemChange({change, skeleton = false}: { change?: ProductVersionChange, skeleton?: boolean }) {
    if (!skeleton && !change)
        return <></>

    return <div className={classNames("change-item", pair("skeleton", skeleton))}>
        {change?.title && <div className="title">{change.title}</div>}
        <div className="explanation">
            {change?.content && parse(change?.content?.replaceAll("\n", "<br />"))}
        </div>
    </div>
}
